import PropTypes from 'prop-types'
import classNames from 'classnames'
// import Image from '../../image'

import Typography from '../../typography'
import { useBreakpoint } from '../../../../hooks/breakpoint'

// import ManPhone from '../../../../public/img/bantrab/decoration-phone-boy.png'

import styles from '../../../../styles/bantrab/components/blog.module.scss'

const Header = ({ title, highlightedTitleText, preTitle, image, ...attrs }) => {
  const breakpoint = useBreakpoint()

  title = title.replace(highlightedTitleText, '')

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'md:pt-0',
      'bg-turquoise-100'
    ],
    {
      [styles.header]: true
    }
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'items-center',
            '-mx-4'
          ])
        }
        style={
          {
            minHeight: '25rem'
          }
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4',
              'pb-6',
              'pt-12',
              'md:pb-12',
              'md:pt-24',
              'flex',
              'flex-col',
              'justify-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <Typography
            size={breakpoint.mdAndUp ? 'four' : 'three'}
            className={'text-green-500 mb-4'}>
            {preTitle}
          </Typography>
          <Typography
            weight={'black'}
            size={breakpoint.mdAndUp ? 'seven' : 'five'}
            className={'text-green-500 mb-0 tracking-tight'}>
            {title}
            <Typography
              tag={'span'}
              weight={'black'}
              size={breakpoint.mdAndUp ? 'eight' : 'six'}
              className={'text-turquoise-600'}>
              {highlightedTitleText}
            </Typography>
          </Typography>
        </div>
        <div
          className={
            classNames([
              breakpoint.mdAndUp ? 'absolute' : '',
              breakpoint.mdAndUp ? 'top-0' : '',
              breakpoint.mdAndUp ? 'bottom-0' : '',
              breakpoint.mdAndUp ? 'left-1/2' : '',
              breakpoint.mdAndUp ? 'right-0' : '',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%',
            height: breakpoint.mdAndUp ? '100%' : '18rem'
          }}>
          {
            (image && image.meta)
              ? <div
                className={
                  classNames([
                    'bg-cover',
                    'bg-top',
                    'h-full',
                    'w-full'
                  ])
                }
                style={{
                  borderRadius: breakpoint.mdAndUp ? '7.5rem 0 0 0' : '0',
                  backgroundImage: `url('${image.meta.downloadUrl}')`
                }}>
              </div>
              : null
          }
        </div>
      </div>
    </div>
  </section >
}

Header.propTypes = {
  title: PropTypes.string,
  highlightedTitleText: PropTypes.string,
  preTitle: PropTypes.string,
  image: PropTypes.object
}
export default Header
